// extracted by mini-css-extract-plugin
export var resizer = "_eb-0";